<template>
  <div>
    <div class="d-flex align-items-center m-4">
      <span class="icon icon-Account h3 mr-2 text-primary" />
      <span class="h5">User Location</span>
      <div class="ml-auto">
        <b-nav pills>
          <b-nav-item class="mx-2" v-for="tab in tabs" :key="tab.title" :active="tab.title === activeTabTitle" @click="activeTabTitle = tab.title">{{ tab.title }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <keep-alive>
      <component :is="activeTab.component" :options="options"></component>
    </keep-alive>
  </div>
</template>

<script>
import GlobalView from '@/reports/components/maps/GlobalView'
import StatesView from '@/reports/components/maps/StatesView'

export default {
  name: 'MapsView',
  props: {
    options: { type: Object }
  },
  data () {
    return {
      tabs: [
        { title: 'Global', component: GlobalView },
        { title: 'USA', component: StatesView }
      ],
      activeTabTitle: 'Global'
    }
  },
  computed: {
    activeTab () {
      return this.tabs.find(tab => tab.title === this.activeTabTitle)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/User/MapsView.vue